import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import ExPagination from '../../components/molecules/ExPagination';
// import TablePagination from '../../components/molecules/TablePagination';
import GroupLinkTableHead from '../../components/molecules/GroupLinkTableHead';
import GroupLinkTableBody from '../../components/molecules/GroupLinkTableBody';
import GroupDetail from './GroupDetail';
// import GroupEdit from './GroupEdit';
import ConfirmDialog from '../../components/molecules/ConfirmDialog';

const styles = {
  scrollTable: {
    maxHeight: 375,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(state => ({
    name: state.loginInfo.name,
    groups: state.groups.groups,
    totalCount: state.groups.totalCount,
    offset: state.groups.offset
  })),
  setPropTypes(propTypes),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openConfirm', 'updateOpenConfirm', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('prefecture', 'setPrefecture', 40),
  withState('targetRowId', 'setTargetRowId', 0),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'userId'),
  withState('page', 'setPage', 0),
  withHandlers({
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    classes,
    page,
    selectedPage,
    totalCount,
    offset,
    handleChangePage,
    groups,
    openDetailModal,
    updateOpenDetailModal,
    // openEditModal,
    updateOpenEditModal,
    openConfirm,
    updateOpenConfirm,
    // openEditConfirm,
    // updateOpenEditConfirm,
    rowsPerPage,
    targetRowId,
    setTargetRowId,
    order,
    orderBy,
    handleChangeRowsPerPage,
    handleRequestSort
  }) => {
    const emptyRows =
      rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const okAction = () => {
      updateOpenConfirm(false);
    };
    return (
      <div>
        <div className={classes.scrollTable} id="scrollTableId">
          <Table stickyHeader>
            <GroupLinkTableHead
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
            />
            <GroupLinkTableBody
              groups={groups}
              emptyRows={emptyRows}
              page={page}
              rowsPerPage={rowsPerPage}
              updateOpenDetailModal={updateOpenDetailModal}
              updateOpenEditModal={updateOpenEditModal}
              updateOpenConfirm={updateOpenConfirm}
              order={order}
              orderBy={orderBy}
              setTargetRowId={setTargetRowId}
            />
          </Table>
        </div>
        <div>
          <ExPagination
            searchResults={groups}
            rowsPerPage={rowsPerPage}
            page={page}
            handleChangePage={handleChangePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            totalCount={totalCount}
            offset={offset}
            selectedPage={selectedPage}
          />
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
        >
          <GroupDetail
            updateOpenDetailModal={updateOpenDetailModal}
            updateOpenEditModal={updateOpenEditModal}
            targetRowId={targetRowId}
          />
        </Modal>
        {/* 新・GroupSearchに合わせてGroupEditを改修したため、こちらでも使用する場合は呼び出し方を合わせる */}
        {/* <Modal
          open={openEditModal}
          onClose={() => {
            updateOpenEditModal(false);
          }}
        >
          <GroupEdit
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            targetRowId={targetRowId}
          />
        </Modal> */}
        <ConfirmDialog
          openConfirm={openConfirm}
          updateOpenConfirm={updateOpenConfirm}
          okAction={okAction}
          message="グループ運営会社に対して店舗紐付け申請を行います。よろしいですか？(グループ運営会社から承認されるまで紐付けされません)"
        />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
